// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Ac-z","title":"Bc-z","cta":"Cc-z","disabled":"Dc-z"};